import { render, staticRenderFns } from "./Sfcheck-table.vue?vue&type=template&id=6b7db3aa&scoped=true"
import script from "./Sfcheck-table.vue?vue&type=script&lang=js"
export * from "./Sfcheck-table.vue?vue&type=script&lang=js"
import style0 from "./Sfcheck-table.vue?vue&type=style&index=0&id=6b7db3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7db3aa",
  null
  
)

export default component.exports